<template>
  <v-row class="ma-0">
    <v-col>
      <div v-if="zones.zonesChanges.add.length < 1" class="no-zone">
        <span>{{ $t('map.tolldomains.overview.no_new_zones') }}</span>
        <img :src="require('@/assets/images/overview-world-star.svg')" alt="overview-world-star" />
      </div>
      <div v-if="zones.zonesChanges.add.length > 0" class="map-container">
        <l-map
          v-if="mapLoaded && index === 2"
          ref="new-zones-map"
          :options="{ preferCanvas: true }"
          @ready="onMapReady"
        >
          <l-tile-layer v-bind="tilesOpts" />
        </l-map>
      </div>
    </v-col>
    <v-col class="col-5 pa-0 overview-container">
      <span class="confirm-zones">{{ $t('map.tolldomains.overview.confirm_new_zones') }}</span>
      <v-row class="list-card">
        <v-col class="pa-0">
          <v-row class="ma-0">
            <div class="list-card-title mb-3">{{ $t('map.tolldomains.overview.new_zones_list') }}</div>
          </v-row>
          <v-row class="ma-0">
            <div v-if="zones.zonesChanges.add.length > 0" class="list-container">
              <div class="column-header">
                <span>&nbsp;</span>
                <span>{{ $t('map.tolldomains.global_information.tsp_code') }}</span>
                <span>{{ $t('map.tolldomains.global_information.country_code') }}</span>
                <span>{{ $t('map.tolldomains.global_information.provider_identifier') }}</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
              </div>
            </div>
          </v-row>
          <v-row class="ma-0">
            <div v-if="zones.zonesChanges.add.length > 0" class="list-container">
              <div v-for="(zone, index) in zones.zonesChanges.add" :key="zone.code" class="list-item-container">
                <span class="item-header">
                  <v-img
                    contain
                    :src="require('@/assets/zones/star.svg')"
                    :aspect-ratio="4 / 2"
                  /></span>
                <v-text-field
                  :id="`zone-name-${zone.id}`"
                  v-model="zone.name"
                  outlined
                  dark
                  dense
                  hide-details="auto"
                  @change="updateZones"
                />
                <v-text-field
                  :id="`zone-code-${zone.code}`"
                  v-model="zone.code"
                  disabled
                  outlined
                  dark
                  dense
                  hide-details="auto"
                />
                <v-text-field
                  :id="`zone-provider-${zone.providerId}`"
                  v-model.number="zone.providerId"
                  outlined
                  dark
                  dense
                  hide-details="auto"
                  :rules="providerIdentifierRules"
                  @change="updateZones"
                />
                <span class="text-center">{{ zone.id }}</span>
                <span class="zoneVisibility" :class="[zoneVisibility[index] ? 'zoneActive' : 'zoneInactive']" @click="displayMap(zone.code, index)" />
              </div>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import L from 'leaflet';
import Validation from '@/mixins/Validation';
import { LMap, LTileLayer } from 'vue2-leaflet';
import { MAP_ATTRIBUTION, TILES_URL } from '@/constants/map/mapConstants';
import { GeoJsonObject } from 'geojson';

@Component({
  components: {
    LMap,
    LTileLayer
  }
})
export default class OverviewNewZones extends Mixins(Validation) {
  @Prop()
  private index!: number;

  @Prop()
  private zones!: any;

  @Prop()
  private mapLoaded!: boolean;

  private zoneVisibility:boolean[] = [];

  private map: L.Map;

  private layers: any = {};

  private geoGroup: L.FeatureGroup;

  private tilesOpts = {
    url: TILES_URL,
    attribution: MAP_ATTRIBUTION
  };

  private providerID = {
    min: 0,
    max: 16383
  };

  private providerIdentifierRules = [
    this.requiredRule('common.error.forms.inputs.validator.mandatory'),
    this.range(this.providerID.min, this.providerID.max, 'common.error.forms.inputs.validator.out_of_range')
  ];

  private layerStyle = {
    color: '#ff8c1f',
    weight: 2,
    opacity: 1
  };

  private onMapReady() {
    if (this.zones.zonesChanges.add.length > 0) {
      const mapComponent = this.$refs['new-zones-map'] as LMap;
      mapComponent.mapObject.invalidateSize();
      this.map = mapComponent.mapObject;
      this.geoGroup = L.featureGroup();
      this.zoneVisibility = Array(this.zones.zonesChanges.add.length).fill(true);
      this.zones.zonesChanges.add.forEach((zone: any) => {
        const geo = JSON.parse(zone.geo);
        this.addLayer(zone.code, geo);
      });
      this.map.fitBounds(this.geoGroup.getBounds());
    }
  }

  private displayMap(id: string, index: number) {
    this.$set(this.zoneVisibility, index, !this.zoneVisibility[index]);
    if (this.layers[id].toggle) {
      this.layers[id].map.remove();
    } else {
      this.layers[id].map.addTo(this.map);
    }
    this.layers[id].toggle = !this.layers[id].toggle;
  }

  private addLayer(name: string, map: GeoJsonObject) {
    const layer = L.geoJSON(map, { style: this.layerStyle });
    this.layers[name] = { toggle: true, map: layer.addTo(this.map) };
    this.geoGroup.addLayer(layer);
  }

  private updateZones() {
    this.$emit('updateZones', this.zones.zonesChanges);
  }
}
</script>
<style lang="scss" scoped>
@import './styles/overview-new-zones.scss';
</style>
